export const RouteConstants = {
  root: '/',
  defaultRoute: '/data-sources',
  home: '/home',
  callbackLanding: '/cb',
  logout: '/logout',
  createWorkspace: '/create-workspace',
  createCompany: '/create-company',
  dataSources: '/data-sources',
  dataSourcesCatalog: '/data-sources?catalog',
  dataSourcesCreate: '/data-sources/create/:id',
  audiences: '/audiences',
  audiencesCreate: '/audiences/create',
  destinations: '/destinations',
  createDestination: '/destinations/create',
  createCustomDestination: '/destinations/create-custom',
  reports: '/reports',
  componentShowcase: '/components-list',
  settings: '/settings',
  company: '/settings/company',
  cyclrAuthRedirect: '/cyclr/auth/redirect',
  campaigns: '/campaigns',
  createCampaign: '/campaigns/create',
  support: '/support',
  unifiedProfiles: '/unified-profiles',
  resetPassword: '/reset-password',
} as const;

export const SidebarRoutes = [
  RouteConstants.home,
  RouteConstants.campaigns,
  RouteConstants.dataSources,
  RouteConstants.audiences,
  RouteConstants.destinations,
  RouteConstants.unifiedProfiles,
  RouteConstants.reports,
  RouteConstants.componentShowcase,
  RouteConstants.settings,
  RouteConstants.cyclrAuthRedirect,
];

export default RouteConstants;
